export default {

  methods: {
    set_WeekPerformance(selection, dataSet) {
      let wk = this.week
      let x_ = 0, gap = 0, width = 0
      
      dataSet.forEach((d,i)=> {
        if(d.WEEK =='LAST' || d.WEEK =='THIS') {
          width = wk.width[0]
          d.name = 'Total'
          d.tColor = '#333'
        } else {
          width = wk.width[1]
          d.name = d.WEEK
          d.tColor = '#bcbcbc'
        }
        if(i==0 || i==7) gap = wk.wGap * 2; else gap = wk.wGap

        d.value = d.VALUE
        d.sx = x_
        d.mx = x_ + (width/2)
        d.width = width
        x_ = x_ + width + gap
      })

      this.fChart_WeekPerformance(selection, dataSet, wk) // ----->  Below
    },



    fChart_WeekPerformance(selection, weekData, wk) {

      let weekStatus = selection
      .append('g')
      .attr('transform', `translate(${wk.x}, ${wk.y})`)
      .attr('font-family', 'roboto')

      this.gmx_Text(weekStatus, '', weekData[0].mx, 8, 10, '#757575', 'middle', 'central', 'LAST WEEK')
      this.gmx_Line(weekStatus, weekData[1].mx, weekData[8].mx, 8, 8, '#bcbcbc', .3, 1)

      weekStatus
      .append('rect')
      .attr('x', weekData[4].sx).attr('y', 7).attr('width', (wk.width[1]+wk.wGap) * 2).attr('height', 2).attr('fill', '#fff')

      this.gmx_Text(weekStatus, '', weekData[5].sx, 8, 10, wk.tColor, 'middle', 'central', 'THIS WEEK')

      weekData.forEach((d,i)=> {
        weekStatus
        .append('text')
        .attr('x', d.mx).attr('y', 26)
        .attr('font-size', 10).attr('fill', d.tColor).attr('text-anchor', 'middle')
        .text(d.name)

        weekStatus
        .append('rect')
        .attr('transform', `translate(${d.sx}, 30)`)
        .attr('width', d.width).attr('height', 14).attr('stroke-width', .3)
        .attr('stroke', (d.name == 'Total') ? wk.stroke : '#bcbcbc')
        .attr('fill', (d.name != 'Total' && d.value > 0) ? '#F4F5F5' : '#fff')

        weekStatus
        .append('text')
        .attr('id', `WEEK_${i}_${this.localId}`)
        .attr('transform', `translate(${d.mx}, 41)`)
        .attr('font-size', 10).attr('fill', d.VALUE==0 ? '#E0E0DF' :'#333')
        .attr('text-anchor', 'middle')
        .text(d.VALUE)
        .call(this.call_WeekPerformance, d.WEEK) // ---> Below

      })
    },

  }
}